import Image from 'next/image';
import candor from './logos/candor.svg';
import covalent from './logos/covalent.svg';
import grafbase from './logos/grafbase.svg';
import honeylove from './logos/honeylove.svg';
import level from './logos/level.svg';
import pano from './logos/pano.svg';
import saasgrid from './logos/saasgrid.svg';
import seam from './logos/seam.svg';

const companies = [
  { name: 'Candor', logo: candor },
  { name: 'Level', logo: level },
  { name: 'Grafbase', logo: grafbase },
  { name: 'Seam', logo: seam },
  { name: 'Honeylove', logo: honeylove },
  { name: 'Pano', logo: pano },
  { name: 'Covalent', logo: covalent },
  { name: 'SaaSGrid', logo: saasgrid }
];

export function Partners() {
  return (
    <div className="relative mt-10 space-y-4 px-4 sm:px-6">
      <h3 className="text-center text-[0.875rem] font-medium leading-6 text-primary">
        Trusted by fast-growing companies around the world
      </h3>
      <ul
        role="list"
        className="flex flex-auto flex-wrap items-center justify-center gap-4 lg:flex-nowrap"
      >
        {companies.map(company => (
          <li key={company.name}>
            <Image src={company.logo} alt={company.name} unoptimized />
          </li>
        ))}
      </ul>
    </div>
  );
}
